import { Typography } from '@mui/material';


function ProgramLocation(props) {
  let { program, className, style, sx, component, to, color, paragraph} = props;
  let location = "";
  if (program?.city) location= program.city;
  if (program?.stateProvince) location= location + " " + program.stateProvince;
  

  

  return (
	
		  <Typography
	              sx={sx}
	              className={className}
	              style={style}
	              component={component}
	              to={to}
	              color={color}
	              paragraph={paragraph}
	            >
	              {(program.programType || program.type) + (location !== "" ? ", " + location : "")}
	      </Typography> 
	      
  );
  
}


export default ProgramLocation;